import { render, staticRenderFns } from "./consumerCoupon.vue?vue&type=template&id=31ec29ee&scoped=true&"
import script from "./consumerCoupon.vue?vue&type=script&lang=js&"
export * from "./consumerCoupon.vue?vue&type=script&lang=js&"
import style0 from "./consumerCoupon.vue?vue&type=style&index=0&id=31ec29ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec29ee",
  null
  
)

export default component.exports